<template>
  <div class="home">
    <div v-if="ismobile" class="tops">
      <img src="../static/logo_icon.png" class="logos" alt="" />
      <ul class="top_ul">
        <li
          class="top_li"
          :class="$route.path.indexOf(item.url) != -1 ? 'bgred' : 'bgwhite'"
          v-for="item in list"
          :key="item.id"
          @click="choosetop(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div v-if="!ismobile" class="topmo">
      <img src="../static/logo_icon.png" class="logos" alt="" />
      <div @click="drawer = true">
        <img class="imgicon" src="../static/choose_icon.png" alt="" />
      </div>
    </div>
    <!-- 中间 -->
    <div :class="ismobile ? 'main' : 'mainmo'">
      <router-view></router-view>
    </div>
    <!-- <div class="imgkefu">
      <img class="kefu_img" src="../static/kefu_icon.png" alt="" />
    </div> -->
    <!-- 底部 -->
    <footer :class="!ismobile ? 'footmo' : 'foots'">
      <div class="foots_top">
        <ul class="foot_ul">
          <!-- <li v-if="ismobile">
            <img class="fires" src="../static/fire.png" alt="" />
          </li> -->
          <li
            class="foot_lis"
            @click="choosetop(item)"
            :class="$route.path.indexOf(item.url) != -1 ? 'afff' : ''"
            v-for="(item, index) in footlist"
            :key="item.name"
          >
            <div>
              <img
                v-if="index == 0"
                class="fires"
                src="../static/fire.png"
                alt=""
              />
              <a class="aaas" :href="item.url">{{ item.name }}</a>
            </div>
            <div
              class="foot_li"
              v-for="(item1, index) in item.text"
              :key="index"
            >
              <a class="aaab" :href="item1.url">{{ item1.name }}</a>
            </div>
          </li>
        </ul>
        <!-- 二维码 -->
        <div class="ewm_list">
          <div class="erweima_item">
            <img class="ewmimgs" src="../static/ewm1.png" alt="" />
            <div>
              <div>扫码关注</div>
              <div>官方微信公众号</div>
            </div>
          </div>
          <div class="erweima_item">
            <img class="ewmimgs" src="../static/ewm2.png" alt="" />
            <div>
              <div>扫码关注</div>
              <div>官方抖音账号</div>
            </div>
          </div>
        </div>
        <div class="kefu">
          <img src="../static/phone_icon.png" class="phone_icon" alt="" />
          <div>
            <div>客服服务热线</div>
            <div class="kefuphone">0731-55555579</div>
          </div>
        </div>
      </div>
      <div class="banquan">
        <div>
          Copyright © 2021 Huicairen.net. 湖南荟才人力资源管理服务有限公司
          版权所有 湘ICP备2021013929号 技术支持：初心不二
        </div>
      </div>
    </footer>
    <el-drawer
      size="70%"
      :show-close="false"
      :visible.sync="drawer"
      direction="ltr"
    >
      <div
        v-for="item in list"
        @click="choosetop(item)"
        :key="item.id"
        class="drawers"
      >
        <span
          :class="$route.path.indexOf(item.url) != -1 ? 'drawers_item' : ''"
        >
          {{ item.name }}
        </span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      drawer: false,
      windowWidth: document.documentElement.clientWidth,
      chooseid: 0,
      footlist: [
        {
          name: "热门推荐",
          url: "https://www.huicairen.net/bk_LMM1733193169604.html",
          text: [
            {
              name: "热招职位",
              url: "热招职位",
            },
            {
              name: "求职登记",
              url: "求职登记",
            },
          ],
        },
        {
          name: "荟才简介",
          url: "https://www.huicairen.net/bk_YWN1762784435674.html",
          text: [
            {
              name: "关于我们",
              url: "https://www.huicairen.net/bk_YWN1762784435674.html",
            },
            {
              name: "企业文化",
              url: "http://www.huicairen.net/p-77.html",
            },
            {
              name: "内部招聘",
              url: "https://www.huicairen.net/bk_XXV1762784459018.html",
            },
          ],
        },
        {
          name: "解决方案",
          url: "https://www.huicairen.net/bk_LMM1733193169604.html",
          text: [
            {
              name: "制造业外包",
              url: "https://www.huicairen.net/bk_LMM1733193169604.html",
            },
            {
              name: "人力资源服务外包",
              url: "https://www.huicairen.net/bk_DBJ1743426779830.html",
            },
            {
              name: "招聘全流程外包",
              url: "https://www.huicairen.net/bk_RPU1743487402231.html",
            },
            {
              name: "业务流程外包",
              url: "https://www.huicairen.net/bk_MMZ1743568974651.html",
            },
            {
              name: "灵活用工服务",
              url: "https://www.huicairen.net/bk_BKP1743573128545.html",
            },
            {
              name: "专业咨询与培训",
              url: "https://www.huicairen.net/bk_DHH1743644796143.html",
            },
          ],
        },
        {
          name: "新闻资讯",
          url: "https://www.huicairen.net/bk_YWN1762784435674.html",
          text: [
            {
              name: "资讯动态",
              url: "https://www.huicairen.net/bk_IVS1762937080691.html",
            },
            {
              name: "职场攻略",
              url: "https://www.huicairen.net/bk_OJQ1762937096462.html",
            },
            {
              name: "工厂百科",
              url: "https://www.huicairen.net/bk_VMN1762937129724.html",
            },
          ],
        },
      ],
      list: [
        {
          id: 0,
          name: "首页",
          url: "http://www.huicairen.net",
        },
        {
          id: 1,
          name: "热招职位",
          url: "/hotwork",
        },
        {
          id: 2,
          name: "求职登记",
          url: "/qiuz",
        },
        {
          id: 3,
          name: "新闻资讯",
          url: "https://www.huicairen.net/bk_YWN1762784435674.html",
        },
        {
          id: 4,
          name: "解决方案",
          url: "https://www.huicairen.net/bk_LMM1733193169604.html",
        },
        {
          id: 5,
          name: "关于荟才",
          url: "https://www.huicairen.net/bk_YWN1762784435674.html",
        },
        {
          id: 6,
          name: "联系我们",
          url: "https://www.huicairen.net/bk_ONX1733193186586.html",
        },
      ],
    };
  },
  computed: {
    ismobile() {
      console.log(this.windowWidth);
      if (this.windowWidth > 500) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    choosetop(item) {
      this.drawer = false;
      console.log(item);
      this.chooseid = item.id;
      if (item.url.indexOf("http") == -1) {
        if (item.url && this.$route.path != item.url) {
          this.$router.push(item.url);
        } else {
          // this.$router.push("/");
          return;
        }
      } else {
        location.href = item.url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ewmimgs {
  width: 115px;
  height: 115px;
}
a {
  color: #333;
  text-decoration: none;
}
.afff {
  color: #da251c;
}
.imgkefu {
  position: fixed;
  top: 485px;
  right: 13px;

  .kefu_img {
    width: 310px;
    height: 110px;
  }
}
.drawers {
  width: 100%;
  text-align: center;
  font-size: 18px;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #999;
}
.drawers_item {
  color: #da251c;
  border-bottom: 4px solid #da251c;
  padding-bottom: 16px;
}
.topmo {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 100;
  .logos {
    width: 115px;
    height: 40px;
  }
  .imgicon {
    width: 25px;
    height: 25px;
  }
}
.tops {
  width: 100%;
  height: 100px;
  padding: 0 155px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 100;
  .logos {
    width: 350px;
    height: 80px;
  }
  .top_ul {
    list-style: none;
    display: flex;
    align-items: center;
  }
  .top_li {
    width: 140px;
    height: 100px;
    // background: #da251c;
    text-align: center;
    line-height: 100px;
    font-size: 18px;
    cursor: pointer;
  }
  .top_li:hover {
    background: #da251c;
    color: #fff;
    transition: all linear 0.2s;
  }
  .bgred {
    background: #da251c;
    color: #fff;
  }
  .bgwhite {
    background: #fff;
  }
}
.mainmo {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;
  margin-top: 50px;
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;
  margin-top: 100px;
}
.footmo {
  display: block;
  width: 80%;
  // height: 378px;
  background-color: #fff;
  padding: 60px 0px 30px;
  margin: auto;
  .foot_ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
  }
  .fires {
    // margin-right: 10px;
    width: 20px;
    height: 20px;
    margin-left: -20px;
  }
  .foot_lis {
    width: 50%;
    // height: 40px;
    // display: flex;
    text-align: center;
    // line-height: 40px;
    // margin-bottom: 40px;
    // cursor: pointer;
    // margin-right: 40px;
    font-size: 18px;
    color: #000;
  }
  .foot_li {
    // display: flex;
    width: 100%;
    font-size: 16px;
    color: #999;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // margin-bottom: 40px;
    cursor: pointer;
  }
  // .aaas:hover {
  //   color: #db2121;
  // }
  .aaab {
    color: #999;
  }
  .foot_li:hover {
    color: #db2121;
  }
  // .foots_top {
  //   width: 100%;
  //   display: flex;
  //   align-items: flex-start;
  //   justify-content: space-between;
  //   margin-bottom: 117px;
  // }
  // .ewm_list {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   width: 326px;
  // }
  .erweima_item {
    display: flex;
    align-items: center;
    // flex-direction: column;
  }
  .kefu {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;
    margin-top: 30px;
    .kefuphone {
      font-size: 24px;
      color: #da251c;
      font-weight: bold;
      margin-top: 10px;
    }
  }
  .phone_icon {
    width: 70px;
    height: 70px;
    margin-right: 14px;
  }
  .banquan {
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // width: 690px;
  }
}
// 底部
.foots {
  width: 80%;
  // height: 378px;
  background-color: #fff;
  padding: 60px 0px 30px;
  margin: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .foot_ul {
    display: flex;
    // flex-wrap: wrap;
    align-items: flex-start;
  }
  .fires {
    margin-right: 10px;
    width: 40px;
    height: 40px;
  }
  .foot_lis {
    // width: 25%;
    // height: 40px;
    text-align: center;
    line-height: 40px;
    // margin-bottom: 40px;
    cursor: pointer;
    margin-right: 40px;
    font-size: 18px;
    color: #000;
  }
  .foot_li {
    // width: 25%;
    font-size: 16px;
    color: #737373;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // margin-bottom: 40px;
    cursor: pointer;
  }
  .aaas:hover {
    color: #db2121;
  }
  .foot_li:hover {
    color: #db2121;
  }
  .foots_top {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 117px;
  }
  .ewm_list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 326px;
  }
  .erweima_item {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .kefu {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;
    margin-top: 30px;
    .kefuphone {
      font-size: 24px;
      color: #da251c;
      font-weight: bold;
      margin-top: 10px;
    }
  }
  .phone_icon {
    width: 70px;
    height: 70px;
    margin-right: 14px;
  }
  .banquan {
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // width: 690px;
  }
}
</style>
